import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  min-height: 250px;\n  background-color: #f1f1f1;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media screen and (max-width: ', ') {\n    min-height: 200px;\n  }\n'], ['\n  min-height: 250px;\n  background-color: #f1f1f1;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media screen and (max-width: ', ') {\n    min-height: 200px;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  max-width: 650px;\n  margin: 0 auto;\n  padding: 2em 20px;\n  text-align: center;\n'], ['\n  max-width: 650px;\n  margin: 0 auto;\n  padding: 2em 20px;\n  text-align: center;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  font-size: 32px;\n'], ['\n  font-size: 32px;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  font-size: 22px;\n  font-weight: 500;\n\n  @media screen and (max-width: ', ') {\n    font-size: 20px;\n  }\n'], ['\n  font-size: 22px;\n  font-weight: 500;\n\n  @media screen and (max-width: ', ') {\n    font-size: 20px;\n  }\n']);

import styled from 'styled-components';

export var StyledWrapper = styled.div(_templateObject, function (props) {
  return props.theme.tabletWidth;
});

export var StyledHeaderSection = styled.div(_templateObject2);

export var StyledHeader = styled.h3(_templateObject3);

export var StyledSubheader = styled.h4(_templateObject4, function (props) {
  return props.theme.tabletWidth;
});